const calcPercentage = (value?: number, limit?: number): number => {
  if (value && limit) {
    if (value >= limit) {
      return 100;
    } else {
      return (value * 100) / limit;
    }
  } else {
    return 0;
  }
};

export { calcPercentage };
